/* unplugin-vue-components disabled */import { render } from "./item-mm-mcq.vue?vue&type=template&id=0cd2d9d6"
import script from "./item-mm-mcq.vue?vue&type=script&lang=js"
export * from "./item-mm-mcq.vue?vue&type=script&lang=js"

import "./item-mm-mcq.vue?vue&type=style&index=0&id=0cd2d9d6&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__